import type { Board } from "../../board";
import { DistanceMap } from "../../distanceMap";
import { PRIORITY_LAST, type ProcessableThing } from "../../interfaces";
import { PhysicalThing } from "../../physicalThing";
import { deserializeXY } from "../../serialization";
import { WarningFloor } from "../floors/warningFloor";
import { RobotSpawner } from "../robotSpawner";
import { Sound } from "../sounds/sound";
import { SoundId } from "../sounds/soundId";
import type { XY } from "../../xy";
import { ZOrder } from "../../zOrder";

export class ActivateRobotSpawnersTrap extends PhysicalThing implements ProcessableThing {
	static key = "ActivateRobotSpawnersTrap";
	constructor(xy: XY) {
		super(xy, false);
	}

	isVisible(): boolean {
		return false;
	}

	getZOrder(): number {
		return ZOrder.ITEM_ON_FLOOR;
	}

	processTurn(board: Board): void {
		const player = board.player;
		if (!player) return;

		// The player's own cell blocks movement, so OR it in — otherwise the flood treats
		// the player as a wall and never reaches them.
		const reachable = DistanceMap.buildFrom(board, this.xy, (xy) => {
			if (board.getThingOfClass(WarningFloor, xy) !== null) return false;
			return board.isPassable(xy) || xy.equals(player.xy);
		});
		if (!reachable.has(player.xy)) return;

		for (const thing of board.getPhysicalThings()) {
			if (thing instanceof RobotSpawner) {
				thing.setActive(true);
			}
			if (thing instanceof ActivateRobotSpawnersTrap) {
				board.removeAtEndOfTurn(thing);
			}
		}
		board.addNonPhysicalThing(new Sound(SoundId.ROBOT_BASE_ALARM));
	}

	getProcessPriority(): number {
		return PRIORITY_LAST;
	}

	static deserialize(data: any): ActivateRobotSpawnersTrap {
		const t = new ActivateRobotSpawnersTrap(deserializeXY(data.xy));
		t.visualId = data.visualId;
		return t;
	}
}
